import { usePostHog } from '@posthog/react';
import { cn } from '@seller-hermes/utils/cn';
import { ArrowUpRight, Radio, X } from 'lucide-react';
import * as React from 'react';

const SIGNUP_URL = 'https://live.zoho.com/fpoh-gxy-lps';
const ART_URL =
  'https://cdn.abbiamolog.com/abbiamo-email-templates/newsletter-updates/2026-10-09-demo-friday.jpg';
const DISMISSED_KEY = 'announcement_demo_friday_2026_10_09_dismissed';
// Some sozinho depois do fim da live (BRT não tem horário de verão desde 2019).
const HIDE_AFTER = new Date('2026-10-09T17:00:00-03:00').getTime();

function readStorage(key: string): string {
  if (typeof window === 'undefined') return '';
  try {
    return window.localStorage.getItem(key) ?? '';
  } catch {
    return '';
  }
}

function writeStorage(key: string, value: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* ignore (modo privado / storage cheio) */
  }
}

/**
 * Card flutuante (canto inferior direito) convidando pra live Demo Friday de
 * 09/out. Fica por cima do conteúdo em vez de empurrar o layout, porque várias
 * páginas usam h-screen dentro do Inset. Fechável (localStorage) e some
 * sozinho depois da live.
 */
export function DemoFridayCard() {
  const posthog = usePostHog();
  const [dismissed, setDismissed] = React.useState(
    () => readStorage(DISMISSED_KEY) === '1',
  );

  if (dismissed || Date.now() >= HIDE_AFTER) return null;

  const dismiss = () => {
    writeStorage(DISMISSED_KEY, '1');
    setDismissed(true);
    posthog?.capture('demo_friday_card_dismissed');
  };

  return (
    <aside
      aria-label="Convite para a live Demo Friday"
      className={cn(
        'bg-background fixed bottom-4 right-4 z-40 w-[340px] max-w-[calc(100vw-32px)] overflow-hidden rounded-xl border shadow-lg',
        'animate-in fade-in slide-in-from-bottom-4 duration-300',
      )}
    >
      <button
        type="button"
        onClick={dismiss}
        aria-label="Fechar aviso"
        className="bg-background/80 text-muted-foreground hover:text-foreground absolute right-2 top-2 z-10 rounded-full p-1 backdrop-blur"
      >
        <X className="h-4 w-4" />
      </button>

      <a
        href={SIGNUP_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => posthog?.capture('demo_friday_card_art_clicked')}
      >
        <img
          src={ART_URL}
          alt="Demo Friday Abbiamo, 09/out às 16h"
          className="h-[128px] w-full object-cover object-top"
          loading="lazy"
        />
      </a>

      <div className="flex flex-col gap-y-2 p-4">
        <span className="text-green-foreground flex items-center gap-x-1.5 text-xs font-semibold uppercase tracking-wide">
          <Radio className="h-3.5 w-3.5" />
          Live · sexta, 09/out, às 16h
        </span>
        <p className="text-sm font-semibold">
          Demo Friday: uma visão 360º da plataforma
        </p>
        <p className="text-muted-foreground text-sm">
          Live com o time de produto da Abbiamo sobre os lançamentos, correções
          e novas funcionalidades da plataforma. Exclusivo para clientes.
        </p>
        <a
          href={SIGNUP_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => posthog?.capture('demo_friday_card_signup_clicked')}
          className="bg-[#6ED796] text-black hover:opacity-90 mt-1 inline-flex items-center justify-center gap-x-1 rounded-md px-4 py-2 text-sm font-semibold"
        >
          Inscreva-se
          <ArrowUpRight className="h-4 w-4" />
        </a>
      </div>
    </aside>
  );
}
